<template>
  <div v-if="!$store.state.user.id">
    <v-parallax
      dark
      id="main-parallax"
      src="../assets/images/background.png"
      height="500"
    >
      <v-row align="center" justify="center">
        <v-col class="text-center" cols="12">
          <h1 class="mb-4">
            {{ $store.state.site.name }}
          </h1>
          <h4>
            TPU (or TroploPrivateUploader) is a private file hosting community
            platform.
          </h4>
          <br />
          <div>
            <v-btn class="rounded-xl" large to="/dashboard" text outlined>
              Login
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-parallax>
    <v-col>
      <p
        class="text-h4 justify-center text-center"
        v-bind:class="{
          gradient: !$store.state.site.whitelabel,
          troploGradient: $store.state.site.whitelabel
        }"
      >
        Features
      </p>
      <!-- list of features, including "Collections", "Insights", "AutoCollects" with an image on the left and a description aligned on the right using vuetify -->
      <v-card class="mx-auto mt-6" elevation="6" max-width="1000">
        <v-row>
          <v-col cols="12" md="6">
            <v-img
              src="https://i.troplo.com/i/bbfccfe95019.png"
              contain
            ></v-img>
          </v-col>
          <v-col cols="12" md="5">
            <div>
              <h3 class="mb-2 display-1">Collections</h3>
              <p class="">
                Collections are the way to organize and share your uploads, with
                advanced permissions, you can collaborate with others on your
                collections, and even create a public link that can be accessed
                by anyone without a TPU account.
              </p>
            </div>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="mx-auto mt-10" elevation="6" max-width="1000">
        <v-row>
          <v-col cols="12" md="6">
            <v-img
              src="https://i.troplo.com/i/1985c7cf1197.png"
              contain
            ></v-img>
          </v-col>
          <v-col cols="12" md="5">
            <div>
              <h3 class="mb-2 display-1">Insights</h3>
              <p class="float-end justify-end">
                Insights allow you to view detailed statistics about your upload
                habits, such as when you upload.
              </p>
            </div>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="mx-auto mt-10" elevation="6" max-width="1000">
        <v-row>
          <v-col cols="12" md="6">
            <v-img
              src="https://i.troplo.com/i/5d421e0914e0.png"
              contain
            ></v-img>
          </v-col>
          <v-col cols="12" md="5">
            <div>
              <h3 class="mb-2 display-1">AutoCollect</h3>
              <p class="float-end justify-end">
                AutoCollect allows you to programmatically add files you upload
                to collections based on rules you set.<br />For example, you may
                set a rule that adds your upload to a "Games" collection if the
                filename contains "Skyrim"
              </p>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    <v-col class="text-center justify-center">
      <p
        class="text-h4"
        v-bind:class="{
          gradient: !$store.state.site.whitelabel,
          troploGradient: $store.state.site.whitelabel
        }"
      >
        Statistics
      </p>
      <v-row no-gutters class="justify-center text-center">
        <v-col md="2" sm="2" xs="12">
          <v-card class="rounded-xl mx-2 ma-2" elevation="7">
            <v-container class="text-center">
              <p
                class="text-h5"
                v-bind:class="{
                  gradient: !$store.state.site.whitelabel,
                  troploGradient: $store.state.site.whitelabel
                }"
              >
                Site Domains
              </p>
              <b class="text-h4">{{ $store.state.site.stats.domains }}</b>
            </v-container>
          </v-card>
        </v-col>
        <v-col md="2" sm="2" xs="12">
          <v-card class="rounded-xl mx-2 ma-2" elevation="7">
            <v-container class="text-center">
              <p
                class="text-h5"
                v-bind:class="{
                  gradient: !$store.state.site.whitelabel,
                  troploGradient: $store.state.site.whitelabel
                }"
              >
                Site Users
              </p>
              <b class="text-h4">{{ $store.state.site.stats.users }}</b>
            </v-container>
          </v-card>
        </v-col>
        <v-col md="2" sm="2" xs="12">
          <v-card class="rounded-xl mx-2 ma-2" elevation="7">
            <v-container class="text-center">
              <p
                class="text-h5"
                v-bind:class="{
                  gradient: !$store.state.site.whitelabel,
                  troploGradient: $store.state.site.whitelabel
                }"
              >
                Site Uploads
              </p>
              <b class="text-h4">{{ $store.state.site.stats.uploads }}</b>
            </v-container>
          </v-card>
        </v-col>
        <v-col md="2" sm="2" xs="12">
          <v-card class="rounded-xl mx-2 ma-2" elevation="7">
            <v-container class="text-center">
              <p
                class="text-h5"
                v-bind:class="{
                  gradient: !$store.state.site.whitelabel,
                  troploGradient: $store.state.site.whitelabel
                }"
              >
                Site Usage
              </p>
              <b class="text-h4">{{
                fileSize($store.state.site.stats.usage.result)
              }}</b>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
export default {
  name: "Home",
  methods: {
    fileSize(fileSize) {
      let i = -1
      let byteUnits = ["KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
      do {
        fileSize = fileSize / 1024
        i++
      } while (fileSize > 1024)

      return Math.max(fileSize, 0.1).toFixed(1) + byteUnits[i]
    }
  },
  mounted() {
    if (this.$store.state.user.id) {
      this.$router.push("/dashboard")
    }
  },
  watch: {
    "$store.state.user": {
      deep: true,
      handler() {
        if (this.$store.state.user.id) {
          this.$router.push("/dashboard")
        }
      }
    }
  }
}
</script>

<style scoped></style>
